'use strict';
import angular from 'angular';

angular.module('core.category.directives', [])